module.exports = __webpack_public_path__ + "images/emoji/tv.52aa4b11409ea9d4116b.png";